import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { get, post, put, del } from '../request';
import config from '../config';
function Login(props) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
   
    const handleLogin = async () => {
        try {
            post('/delianapi/login', {
                LoginName: username,
                password,
                isActive:1
            }).then(response => {
                if (response.statusCode != 200) {
                    console.error('��¼ʧ��:', response.message);
                }
                else {
                    // �洢 token�������� localStorage Ϊ��  
                    localStorage.setItem('Authorization', response.items[0].userHash);

                    // ��ת������ҳ��  
                    //navigate('/');
                }
            });
        } catch (error) {
            console.error('��¼ʧ��:', error);
        }
    };
    return (
        <div className='inner-page'>
            <section className="page-title">
                <div className="overlay"></div>
            </section>

            <section className="tf-section project-info">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <form action="#">
                                <div className="project-info-form form-login">
                                    <h6 className="title">Login</h6>
                                    <h6 className="title show-mobie"><Link to={`${config.root}/register`} >Register</Link></h6>
                                    <h6 className="title link"><Link to={`${config.root}/register`}>Register</Link></h6>
                                    <p>Enter your credentials to access your account</p>
                                    <div className="form-inner">
                                        <fieldset>
                                            <label>
                                                Email address *
                                            </label>
                                            <input type="text" placeholder="�û���" required value={username} onChange={(e) => setUsername(e.target.value)} />
                                        </fieldset>
                                        <fieldset>
                                            <label>
                                                Password *
                                            </label>
                                            <input type="password" placeholder="����" value={password} onChange={(e) => setPassword(e.target.value)} required />
                                        </fieldset>
                                    </div>
                                    <Link to={`${config.root}/forgetPass`}  className="fogot-pass">Fogot password?</Link>
                                </div>

                                <div className="wrap-btn">
                                    <button onClick={handleLogin} className="tf-button style2">
                                        ��¼
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Login;